import { getDateTimeMask } from '../../../../helpers/utils/utils';

/**
 * Mapper puro DTO real (`findFasesTimelineProcessoService`) → shape de UI —
 * mesma leitura de campos da tela real (`Fase.jsx`, AW2-1107 Etapa 0):
 * `nome`, `dataInicio`, `dataTrabalhoFase`, `dataTermino`, `negociador`.
 *
 * `atual` NÃO existe no DTO real — a tela real deriva a fase atual pela
 * POSIÇÃO no array (`isFaseAtual = i === 0`, o backend já retorna em ordem
 * reverso-cronológica, fase atual primeiro), replicado aqui do mesmo jeito.
 *
 * `getDateTimeMask` (mesma função pura já usada pela tela real) formata os
 * 3 campos de data — retorna string vazia para data ausente (cobre
 * `dataTermino` da fase atual, que ainda não tem saída).
 */
export function mapearFasesTimeline(fasesDto) {
  return (fasesDto || []).map((fase, i) => ({
    nome: fase?.nome ?? '',
    atual: i === 0,
    entrada: getDateTimeMask(fase?.dataInicio, true, true, true),
    trabalhado: getDateTimeMask(fase?.dataTrabalhoFase, true, true, true),
    saida: getDateTimeMask(fase?.dataTermino, true, true, true),
    negociador: fase?.negociador ?? '',
  }));
}
